// Fonts are self-hosted @font-face rules in styles/statio.css (Satoshi, Ioskeley Mono).
import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { initAnalytics } from './lib/analytics';
import { preloadRoute } from './lib/lazy';
import './styles/global.css';
import './styles/statio.css';
import './styles/blog.css';

const root = document.getElementById('root')!;
// Navigations run as transitions, so a page whose code is still loading keeps
// the previous page on screen instead of suspending to nothing (src/lib/lazy.ts).
const tree = (
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true }}>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// Prerendered pages carry a marker naming the route their HTML was rendered
// for (see vite-plugins/prerender.ts). Hydrate only when it matches the URL
// we're actually on, dist/index.html doubles as the SPA fallback for
// non-prerendered URLs, where hydrating would mismatch.
const marker = document.querySelector('meta[name="prerender-route"]')?.getAttribute('content');
const current = window.location.pathname.replace(/\/+$/, '') || '/';

// The page's own chunk (its MDX body or tool widget) loads before hydrating, so
// the first client render matches the prerendered HTML. The HTML is already on
// screen meanwhile; only interactivity waits.
void preloadRoute(current).then(() => {
  if (marker && marker === current && root.firstChild) {
    hydrateRoot(root, tree);
  } else {
    if (root.firstChild) root.innerHTML = '';
    createRoot(root).render(tree);
  }
  void initAnalytics();
});
